'use strict';

import componentsModule from './PandoraComponents';
import shellModule from './Pandora';
import agentModule from './PandoraSolutionBuilderAgent';

import './shell.templates';
import extensionGalleryModule from './PandoraSolutionBuilderAgent/modules/ExtensionGallery/mx-extension-gallery.module';
import pushNotificationsModule from './PandoraSolutionBuilderAgent/modules/PushNotifications/module';
import dialogPageModule from './PandoraSolutionBuilderAgent/modules/DialogPage/dialog-view.module';
import dataQueryModule from './PandoraSolutionBuilderAgent/modules/DataQueryModel/module';
import multiSelectionTabModule from './PandoraSolutionBuilderAgent/layouts/multiselection-tab/multiselection-tab.module';
import editFormModule from './PandoraSolutionBuilderAgent/layouts/edit-form/edit-form.module';
import searchPageModule from './PandoraSolutionBuilderAgent/layouts/search-page/search-page.module';
import landingPageModule from './PandoraSolutionBuilderAgent/layouts/landing-page/landing-page.module';
import executorGridModule from './PandoraSolutionBuilderAgent/components/mx-executor-grid/mx-executor-grid.module';
import ownershipModule from './PandoraSolutionBuilderAgent/modules/Ownership/ownership.module';
import attachmentModule from './PandoraSolutionBuilderAgent/modules/Attachment/mx-attachment.module';
import { keepLocationAfterInitShellState } from './shell.states';
import { mxNavigationModule } from './Navigation/navigation.module';
import { AgentAppInitializerService } from './agent-app-initializer.service';
import { publicModule } from './PublicModule/public.module';

// eslint-disable-next-line angular/module-setter
export const shellAgentModule = angular.module('mx.sb.shell-agent', [
	extensionGalleryModule,
	pushNotificationsModule,
	dialogPageModule,
	componentsModule,
	dataQueryModule,
	multiSelectionTabModule,
	editFormModule,
	searchPageModule,
	landingPageModule,
	executorGridModule,
	ownershipModule,
	attachmentModule,
	shellModule,
	componentsModule,
	agentModule,
	mxNavigationModule.name,
	publicModule.name,
]);

export const shellAppModule = angular
	.module('mx.sb.shell-app', [shellAgentModule.name])
	.service('mx.sb.shell-app.AgentInitializerService', AgentAppInitializerService)
	.config([
		'$transitionsProvider',
		function ($transitionsProvider) {
			keepLocationAfterInitShellState($transitionsProvider);
		},
	]);
